import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { DriverPouchAdminDto } from '@/backend/market'
import { DriverPouchEntity } from '../../domain/entities/DriverPouchEntity'

export class DriverPouchModel extends DriverPouchEntity {
  constructor(dataDto: DriverPouchAdminDto) {
    super()
    mapEntityProperties<DriverPouchModel>(this, dataDto, {
      map: {
        amount: dataDto.amount ? (dataDto.amount === 0 ? undefined : dataDto.amount) : undefined,
        defaultMaxAmountLimit: dataDto.defaultMaxAmountLimit
          ? dataDto.defaultMaxAmountLimit === 0
            ? undefined
            : dataDto.defaultMaxAmountLimit
          : undefined
      }
    })
  }
}
